var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[[_c('h3',{staticClass:"title-sidebar"},[_vm._v("Quản lý nội bộ")]),_c('div',{staticClass:"content-sidebar"},[_c('sidebar-item',{attrs:{"link":{
                      name: 'Nhóm đăng bài',
                      path: '/admin-settings/groups',
                      image: '/img/sidebar/right/workplace/group.svg',
                      is_group: false,
                    }}}),_c('sidebar-item',{attrs:{"link":{
                      name: 'Chat bot',
                      path: '/admin-settings/chat-bot',
                      image: '/img/sidebar/right/workplace/group.svg',
                      is_group: false,
                    }}}),_c('sidebar-item',{attrs:{"link":{
                      name: 'Stickers',
                      path: '/admin-settings/stickers',
                      image: '/img/sidebar/right/workplace/group.svg',
                      is_group: false,
                    }}}),_c('sidebar-item',{attrs:{"link":{
                      name: 'Media',
                      path: '/admin-settings/media',
                      image: '/img/sidebar/right/workplace/group.svg',
                      is_group: false,
                    }}}),_c('sidebar-item',{attrs:{"link":{
                      name: 'Biểu mẫu',
                      path: '/admin-settings/forms',
                      image: '/img/sidebar/right/workplace/group.svg',
                      is_group: false,
                    }}}),_c('sidebar-item',{attrs:{"link":{
                      name: 'Báo cáo lỗi',
                      path: '/admin-settings/bug-reports',
                      image: '/img/sidebar/right/workplace/group.svg',
                      is_group: false,
                    }}})],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }